<template>
  <div>
    <div class="modal is-active" v-show="isShowModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Attachment</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-3">
              <div class="field">
                <label class="label is-small">Attach file(s)</label>
                <div class="control">
                  <input
                    type="file"
                    multiple
                    @change="fileChange($event.target.files)"
                    :ref="documentInputRef"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ["documentFiles", "documentInputRef"],
  data: () => ({
    isShowModal: false
  }),
  methods: {
    fileChange(fileList) {
      for (let i = 0; i < fileList.length; i++) {
        this.documentFiles.append(
          "documentFiles",
          fileList[i],
          fileList[i].name
        );
      }

      this.$emit('documentFilesFromAttachFile', {
        documentFiles: this.documentFiles
      })
    },
    closeModal() {
      this.isShowModal = false;
    }
  }
};
</script>
